<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">

        <div class="card-body px-lg-5 py-lg-5" :class="{loading: entrando}">
          <div class="text-center text-muted mb-4">
            <small>Entre com seu e-mail de cadastro.</small>
          </div>
          <base-alert :type="alerta.tipo" v-if="alerta.aberto" :class="{shake: alerta.shake}">
            <span class="alert-inner--icon mr-2">
              <i :class="alerta.icone"></i>
            </span>
            <span class="alert-inner--text">{{alerta.mensagem}}</span>
          </base-alert>

          <form role="form" @submit="doTokenEmail()" v-if="form.one">
            <base-input
              class="input-group-alternative mb-3"
              placeholder="Email"
              addon-left-icon="ni ni-email-83"
              v-model="email.v"
              :error="email.msg"
              name="email"
              @keypress.enter="doTokenEmail()"
            ></base-input>

            <div class="text-center">
              <base-button type="primary" class="my-4" @click="doTokenEmail()">Receber Código</base-button>
            </div>
          </form>

          <form role="form" @submit="waitTokenEmail()" v-if="form.two">
            <base-input
              class="input-group-alternative"
              placeholder="Informe o código"
              type="text"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="code.v"
              :error="code.msg"
              @keypress.enter="waitTokenEmail()"
            ></base-input>

            <div class="text-center">
              <base-button type="primary" class="my-4" @click="waitTokenEmail()">Validar Código</base-button>
            </div>
          </form>

           <form role="form" @submit="updatePassword()" v-if="form.three">
            <base-input
              class="input-group-alternative"
              placeholder="Informe sua nova senha"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="password.v"
              :error="password.msg"
              @keypress.enter="updatePassword()"
            ></base-input>

            <div class="text-center">
              <base-button type="primary" class="my-4" @click="updatePassword()">Atualizar Senha</base-button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
            <router-link to="/login" class="text-light">
                <small>Já possui uma conta?</small>
          </router-link>
        </div>
        <div class="col-6 text-right">
            <a href="https://conectflow.com.br/assinar" class="text-light">
              <small>Assine agora!</small>
            </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import usuario from "@/cflow/usuario.js";
import router from '@/router'
export default {
  name: "login",
  data() {
    return {
      entrando: false,
      alerta: {
        aberto: false,
        shake: false,
        tipo: "",
        mensagem: "",
        icone: "",
      },
        email: { v: "", msg: "" },
        password: { v: "", msg: "" },
        code: { v: "", msg: "" },
        manter: false,
        form: { one: true, two: false, three: false}
    };
  },
  methods: {
    doTokenEmail: function () {
      var app = this;
      app.alerta.shake = false;
      this.entrando = true
      usuario
        .doTokenEmail(this.email.v)
        .then((isValid) => {
          // Se retornou o token então logou:
          if (isValid) {
            app.form = {
                one: false,
                two: true,
                three: false
            }
            app.alerta = {
              aberto: true,
              tipo: "success",
              mensagem: "Verifique seu e-mail e cole o código de recuperação",
              icone: "fas fa-check-circle",
              shake: true
            };
          }
        })
        .catch((error) => {
          if (error.response.data.errors) {
            // Se retornar uma array de erros, botar as mensagens em seus devidos campos.
            Object.entries(error.response.data.errors).forEach(
              ([key, value]) => {
                if (key in app) app[key].msg = value[0];
              }
            );
          }
          // Se retornar uma mensagem de erro:
          if (error.response.data.error) {
            app.email.msg = '';
            app.code.msg = '';
            app.password.msg = '';
            app.alerta = {
              aberto: true,
              tipo: "danger",
              mensagem: error.response.data.error,
              icone: "fas fa-exclamation-triangle",
              shake: true
            };
          }
        }).finally(() => {
          this.entrando = false
        })

    },

    waitTokenEmail: function () {
        var app = this;
        app.alerta.shake = false;
        this.entrando = true
        usuario
            .waitTokenEmail(this.code.v)
            .then((isValid) => {
            if (isValid) {
                app.form = {
                    one: false,
                    two: false,
                    three: true
                }
                app.alerta = {
                aberto: true,
                tipo: "success",
                mensagem: 'Código de validação confirmado. Informe sua nova senha:',
                icone: "fas fa-check-circle",
                };
            }
            })
            .catch((error) => {
            if (error.response.data.errors) {
                // Se retornar uma array de erros, botar as mensagens em seus devidos campos.
                Object.entries(error.response.data.errors).forEach(
                ([key, value]) => {
                    if (key in app) app[key].msg = value[0];
                }
                );
            }
            // Se retornar uma mensagem de erro:
            if (error.response.data.error) {
                app.email.msg = '';
                app.code.msg = '';
                app.password.msg = '';
                app.alerta = {
                aberto: true,
                tipo: "danger",
                mensagem: error.response.data.error,
                icone: "fas fa-exclamation-triangle",
                shake: true
                };
            }
            }).finally(() => {
            this.entrando = false
            })
    },

    updatePassword: function () {
        var app = this;
        app.alerta.shake = false;
        this.entrando = true
        usuario
            .updatePassword(this.code.v, this.password.v)
            .then((isValid) => {
            // Se retornou o token então logou:
            if (isValid) {
                app.form = {
                    one: false,
                    two: false,
                    three: true
                }
                app.alerta = {
                aberto: true,
                tipo: "success",
                mensagem: 'Senha alterada com sucesso! Você será redirecionado ao login...',
                icone: "fas fa-check-circle",
                };

                setTimeout(function(){
                    router.push('/login');
                },2000);
            }
            })
            .catch((error) => {
            if (error.response.data.errors) {
                // Se retornar uma array de erros, botar as mensagens em seus devidos campos.
                Object.entries(error.response.data.errors).forEach(
                ([key, value]) => {
                    if (key in app) app[key].msg = value[0];
                }
                );
            }
            // Se retornar uma mensagem de erro:
            if (error.response.data.error) {
                app.email.msg = '';
                app.code.msg = '';
                app.password.msg = '';
                app.alerta = {
                aberto: true,
                tipo: "danger",
                mensagem: error.response.data.error,
                icone: "fas fa-exclamation-triangle",
                shake: true
                };
            }
            }).finally(() => {
            this.entrando = false
            })
        }
    
  },
};
</script>
<style>
.shake{
    animation: shake 0.35s 1 ease-in;
}
@keyframes shake{
  0%{
    transform: translate3d(0,0,0);
  }
  20%{
    transform: translate3d(-5%,0,0);
  }
  40%{
    transform: translate3d(5%,0,0);
  }
  60%{
    transform: translate3d(-5%,0,0);
  }
  80%{
    transform: translate3d(5%,0,0);
  }
  100%{
    transform: translate3d(0,0,0);
  }
}
</style>
